import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const NotFound: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
			<Card className="w-full max-w-md text-center">
				<CardHeader>
					<CardTitle className="text-2xl font-bold text-gray-900 font-karla">
						Page Not Found
					</CardTitle>
					<p className="text-gray-600 font-karla">
						The page you're looking for doesn't exist.
					</p>
				</CardHeader>
				<CardContent>
					<Button
						onClick={() => navigate("/")}
						className="w-full bg-primary-500 hover:bg-primary-600 text-white"
					>
						Go Home
					</Button>
				</CardContent>
			</Card>
		</div>
	);
};

export default NotFound;
